<template>
  <div class="orderRetrieval">
    <header-item
      :title-array="titleArray"
      :is-show="headShow"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <!-- <common-navbar v-if="$isFlag" /> -->
    <div class="order-retrieval">
      <!-- <button @click="active++">{{ active }}++</button>
      <button @click="active--">{{ active }}--</button> -->
      <div v-if="active == 1" class="order-retrieval-one order-retrieval-common">
        <div class="order-retrieval__step">
          <van-form ref="parentFrom">
            <!-- 请选择操作系统 -->
            <van-field
              name="os"
              style="border-radius: 16px 16px 0 0;"
              label="操作系统："
              :rules="[{ required: true, message: '请选择操作系统' }]"
              class="radio"
            >
              <template #input>
                <van-radio-group v-model="orderParams.os" direction="horizontal">
                  <van-radio name="1">安卓官方</van-radio>
                  <van-radio name="2">雷霆iOS</van-radio>
                  <!-- <van-radio name="3">鸿蒙官方</van-radio> -->
                </van-radio-group>
              </template>
            </van-field>
            <!-- 所玩游戏 -->
            <van-field
              name="game"
              label="所玩游戏："
              class="lt-freeze-select"
              placeholder="请选择您所玩的游戏"
              style="border-radius: 0 0 16px 16px"
              :rules="[{ required: orderParams.os === '210009' ? true : false, message: '' }]"
            >
              <template #input>
                <common-select :selection-info="{selectName:'',columns:columns,label:'name',val:'game'}" @emitParentVal="emitParentVal" />
              </template>
            </van-field>
            <div class="check-order-tips" @click="checkOrderTips">查看商户订单的方式？</div>
            <!-- 充值年份 -->
            <van-field
              name="year"
              label="充值年份："
              class="lt-freeze-select"
              placeholder="请选择您的充值年份"
              style="border-radius: 16px 16px 0 0"
              :rules="[{ required: false, message: '' }]"
            >
              <template #input>
                <common-date :web-date-type="'year'" :picker-options="pickerOptions" :min-date="new Date(2019, 0, 1)" :selection-info="{selectName:''}" @emitTimeVal="emitTimeVal" />
              </template>
            </van-field>
            <!-- 请输入商户订单号 -->
            <van-field
              v-model="orderParams.orderNo"
              label="商户订单："
              placeholder="请输入商户订单号"
              style="border-radius: 0 0 16px 16px"
            />
            <van-field
              v-model="orderParams.phoneNum"
              style="border-radius: 16px 16px 0 0; margin-top: 0.32rem;"
              label="手机号"
              placeholder="请输入能联系到您的手机号"
            />
            <van-field
              v-model="orderParams.phoneCode"
              style="border-radius: 0 0 16px 16px"
              maxlength="6"
              label="短信验证码"
              :rules="rules.codeRules"
              placeholder="请输入验证码"
            >
              <template #button>
                <p
                  v-if="!showTime"
                  style="color: #616edf; cursor: pointer"
                  @click="getCode"
                >{{ timeMsg }}</p>
                <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
              </template>
            </van-field>
            <p v-show="!$isFlag" class="order-retrieval__codetips">
              *如果在1分钟内没有收到短信验证码请重新获取
            </p>
            <div class="bottom">
              <van-button
                round
                block
                type="info"
                color="#616edf"
                class="formClass_btn"
                @click="onSubmitOrder"
              >下一步</van-button>
            </div>
          </van-form>
        </div>
      </div>
      <!-- 查询结果 -->
      <div v-if="active === 2" class="order-retrieval-two">
        <h5 v-if="!bindPhoneListEncrypted.length">亲爱的玩家，您当前的订单号未绑定雷霆账号。</h5>
        <div v-else>
          <!-- <h5>{{ `亲爱的玩家，您当前的身份证绑定了${bindPhoneListEncrypted.length}个雷霆账号：` }}</h5> -->
          <h5>亲爱的玩家，您当前订单号查询到的雷霆账号：</h5>
          <ul>
            <li>雷霆账号</li>
            <li v-for="(item, i) in bindPhoneListEncrypted" :key="i">{{ item }}</li>
          </ul>
          <div class="bottom">
            <van-button
              round
              block
              plain
              type="info"
              color="#616edf"
              class="formClass_btn"
              @click="active = 3"
            >查看完整账号</van-button>
          </div>
          <div class="order-retrieval-two__tips">
            <span>温馨提示：</span>
            <p>1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。</p>
            <p>2.若您已记起完整的账号，可以找回您的账号密码。</p>
          </div>
        </div>
      </div>
      <!-- 填写身份信息查看完整账号 -->
      <van-form v-if="active === 3" class="order-retrieval-three">
        <!-- <h5>查看完整账号</h5> -->
        <van-field
          v-model="formParams.name"
          style="border-radius: 16px 16px 0 0 "
          label="真实姓名"
          :rules="rules.nameRules"
          placeholder="请输入姓名"
        />
        <van-field
          v-model="formParams.idCard"
          label="身份证号码"
          :rules="rules.idRules"
          placeholder="请输入身份证号码"
          style="border-radius: 0 0 16px 16px"
        />
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="checkByIdentity"
          >查询</van-button>
        </div>
      </van-form>
      <!-- 完整雷霆账号信息 -->
      <div v-if="active === 4" class="order-retrieval-four">
        <h5>{{ `亲爱的玩家，您当前查询账号实名与填写身份证匹配的有${usernameListByIdentity.length}个：` }}</h5>
        <ul>
          <li>雷霆账号</li>
          <li v-for="(item, i) in usernameListByIdentity" :key="i">{{ item }}</li>
        </ul>
        <h5 v-if="hideUsernameList.length">以下账号实名信息与填写的身份证信息不一致，无法告知完整的雷霆账号：</h5>
        <ul>
          <!-- <li>雷霆账号</li> -->
          <li v-for="(item, i) in hideUsernameList" :key="i">{{ item }}</li>
        </ul>
        <div class="bottom">
          <van-button
            round
            block
            plain
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="active = 3"
          >重新填写身份信息</van-button>
        </div>
        <!-- <div class="order-retrieval-four__errortips">该身份证今日查询次数已达到上限，请明日再来</div> -->
        <div class="order-retrieval-four__tips">
          <span>温馨提示：</span>
          <p>1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。</p>
          <p>2.若您已记起完整的账号，可以找回您的账号密码。</p>
        </div>
      </div>
      <!-- end -->
    </div>
  </div>
</template>

<script>
import rules from '@/mixins/validator'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import { throttle } from '@/utils/debounce.js'
import commonDate from '@/components/commonDate'
import commonSelect from '@/components/commonSelect'
import * as api from '@/api/account-self-manage/retrieval'
import headerItem from '@/views/accountCenter/common/header'
import { game_list } from '@/api/account-self-manage/accountAppeal'
import { send_phone_code } from '@/api/account-self-manage/accountAppeal'

export default {
  name: 'OrderRetrieval',
  components: {
    headerItem,
    commonDate,
    commonSelect
  },
  mixins: [sendCode],

  props: {
    headShow: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      rules: rules,
      active: 1,
      titleArray: ['通过充值订单找回', '首页', '账号管理中心', '忘记账号', '通过充值订单找回'],
      currentIndex: 0,
      orderParams: {
        phoneNum: '',
        orderNo: ''
      },
      columns: [],
      uploaderBack: [],
      uploaderList: [],
      uploaderFront: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() < 2019
        }
      },
      formParams: {
        name: '',
        idCard: ''
      },
      hideUsernameList: [], // 查询后密文雷霆账号列表
      usernameListByIdentity: [], // 明文雷霆账号列表
      bindPhoneListEncrypted: [] // 密文雷霆账号列表
    }
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.orderRetrieval').className = ['orderRetrieval staffRetrievalH5 accountCommonH5']
    } else {
      document.querySelector('.orderRetrieval').className = ['orderRetrieval staffRetrievalWeb accountCommonWeb']
    }
    game_list().then(res => {
      if (res.status == 0) {
        this.columns = res.data
      }
    })
  },
  methods: {
    getCode() {
      if (!this.orderParams.phoneNum) {
        this.$msg('请输入手机号')
        return
      }
      ltCaptcha((captcha) => {
        send_phone_code({
          phoneNum: this.orderParams.phoneNum,
          type: 'SELF_ACCOUNT_RETRIEVE_ORDER',
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.startTimer()
            this.$msg('短信发送成功', 'success')
          }
        })
      })
    },
    // 通过订单号找回账号
    onSubmitOrder: throttle(function() {
      this.$loading.show()
      api.order_input({
        os: this.orderParams.os,
        year: this.orderParams.year,
        orderNo: this.orderParams.orderNo,
        phoneNum: this.orderParams.phoneNum,
        phoneCode: this.orderParams.phoneCode,
        game: this.orderParams.game
      }).then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          this.active = 2
          this.bindPhoneListEncrypted = res.data
        }
      })
    }, 300),
    // 查看完整雷霆账号 -> 输入实名查看
    checkByIdentity: throttle(function() {
      if (!this.formParams.name || !this.formParams.idCard) {
        this.$msg('身份信息不能为空')
        return
      }
      this.$loading.show()
      api.check_by_identity({
        name: this.formParams.name,
        idCard: this.formParams.idCard
      }).then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          this.active = 4
          this.hideUsernameList = res.data.hideUsernameList
          this.usernameListByIdentity = res.data.usernameListByIdentity
        }
      }, () => {
        this.$loading.hide()
      })
    }, 300),
    emitParentVal(label, val) {
      // this.orderParams.game = val
      this.$set(this.orderParams, 'game', val)
      console.log(label, val, this.orderParams)
    },
    emitTimeVal(val) {
      // this.orderParams.year = val
      this.$set(this.orderParams, 'year', val.slice(0, 4))
      console.log(val, 'regTime', this.orderParams)
    },
    checkOrderTips() {
      this.$dialog.alert({
        title: '查看商品订单的方式',
        messageAlign: 'left',
        message: `1、微信支付商户订单号:
打开微信,然后点击我—服务—钱包-账单(右上角),找到对应的交易记录,点击进去,然后在账单详情页面找到商户单号复制即可。
2、支付宝支付商户订单号:
打开支付宝,然后点击我的—账单,找到对应的交易记录,点击进去,再点击更多,找到商户订单号,点击查看,然后进行复制商户订单号即可。
3、苹果系统支付订单号:
打开App Store,然后点击右上角头像—购买历史,找到对应的交易记录,点击进去,然后复制订单号即可。`
      }).then(() => {
        // on close
        console.log('closed')
      })
    },
    navBarClick() {
      if (this.currentIndex == 1) {
        this.currentIndex = 0
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>
// h5
  .staffRetrievalH5 {
    font-size: 0.25rem;
    background: #f5f7fa;
    // position: relative
    z-index: 99
    h5 {
      color: #5D5D5D
      font-size 0.28rem
      line-height 1.5
      text-align: center
    }
    .order-retrieval {
      margin: auto;
      padding: 0.4rem 0.4rem 0;

      &-common {
        width: 100%;
        margin: 0rem auto 0;
        ::v-deep .van-cell:last-child {
          border-radius: 0 0 16px 16px;
        }
        .formClass_btn {
          width: 100%;
          margin: 0.5rem auto;
        }
      }
      &-btn {
        width: 100%
        display: flex
        justify-content: space-between
        padding-top: 0.3rem
        .van-button {
          width: 3.12rem
          font-size 0.28rem
        }
      }
      &-errortips {
        font-size 0.28rem
        color: #FF3D3D
        line-height 1.5
        padding: 0.4rem 0
        text-align: center
      }
    }
    .check-order-tips {
      width: 100%
      font-size 0.28rem
      color: #606DE2
      line-height 2
      text-align: right
      text-decoration: underline
      padding-top: 0.24rem
    }
    .order-retrieval {
      &-one {
        .formClass_btn {
          // width: 3.12rem
          margin: 0.5rem 0;
        }
        span {
          font-size: 0.26rem;
        }
      }
      &-two,
      &-four {
        ul {
          width: 100%
          padding: 0.32rem 0.4rem
          box-sizing: border-box
          li {
            width: 100%
            color: #5D5D5D
            font-size 0.26rem
            line-height 1.5
            text-align: center
            padding: 0.12rem 0
            box-sizing: border-box
          }
          li:nth-child(2n+1) {
            background-color #ECECEC
          }
        }
        .bottom {
          padding: 0.32rem 0.4rem
        }
        &__errortips {
          color: #FF3D3D
          font-size 0.26rem
          line-height 1.5
          text-align: center
        }
        &__tips {
          padding: 0.4rem 0 0
          span {
            color: #EB8D12
            display: block
            font-size 0.28rem
            line-height 2
          }
          p {
            color: #878787
            font-size 0.26rem
            line-height: 1.5
          }
        }
      }
      &-three {
        h5 {
          padding: 0 0 0.4rem
        }
        .bottom {
          padding 0.4rem 0 0
        }
      }
    }
  }
// web
  .staffRetrievalWeb {
    border-radius: 10px;
    margin-left: 0.2rem;
    margin: 3% 6%;
    font-size: 0.25rem;
    h5 {
      color: #5D5D5D
      font-size 0.32rem
      line-height 1.5
      text-align: center
    }
    .order-retrieval {
      width: 80%;
      margin: auto;
      padding: .5rem;
      &-common {
        width: 70%;
        margin: auto;
      }
      &-btn {
        width: 7.36rem
        display: flex
        justify-content: space-between
        padding-top: 0.3rem
        .van-button {
          width: 3.58rem
        }
      }
      &-three,
      &__step {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        ::v-deep .van-cell {
          font-size: 0.28rem;
          width: 8rem;
        }
      }
      &-two,
      &-four {
        ul {
          width: 60%
          padding: 0.32rem 0.4rem
          box-sizing: border-box
          margin: 0 auto
          li {
            width: 100%
            color: #5D5D5D
            font-size 0.3rem
            line-height 1.5
            text-align: center
            padding: 0.24rem 0
            box-sizing: border-box
          }
          li:nth-child(2n+1) {
            background-color #ECECEC
          }
        }
        &__errortips {
          color: #FF3D3D
          font-size 0.26rem
          line-height 1.5
          text-align: center
        }
        &__tips {
          padding: 0.4rem 0.8rem 0
          span {
            color: #EB8D12
            display: block
            font-size 0.28rem
            line-height 2
          }
          p {
            color: #878787
            font-size 0.26rem
            line-height: 1.5
          }
        }
        .bottom {
          // width: 4.6rem
          padding: 0.32rem 0.4rem
          box-sizing: border-box
          margin: 0 auto
        }
      }
      &__codetips {
        font-size: 0.26rem;
        color: #878787;
        width: 7.5rem;
        line-height: 0.4rem;
      }
      .formClass_btn {
        width: 7.36rem
        margin: 0.64rem auto 0
      }
      &-errortips {
        font-size 0.28rem
        color: #FF3D3D
        line-height 1.75
        padding: 0.4rem 0
        text-align: center
      }
      .radio {
        ::v-deep .van-field__body {
          border: none;
          border-radius: none;
          height: auto;
          padding: 0 0.2rem;
        }
        ::v-deep .van-radio--horizontal {
          margin: 0.2rem 12px 0.3rem 0
        }
      }
      .lt-freeze-select {
        ::v-deep .van-field__body {
          padding: 0
          border: none
          .commonSelect {
            width: 100%
            .selectWebClass {
              padding: 0
              margin: 0
              p {
                display: none
              }
            }
          }
        }
      }
    }
    .check-order-tips {
      width: 100%
      font-size 0.28rem
      color: #606DE2
      line-height 2
      text-align: right
      text-decoration: underline
      padding-top: 0.2rem
      cursor pointer
    }
  }
</style>
